import { createState } from '@/util/storeHelpers'

const interestingPromocodesStore = createState({ key: 'interestingPromocodes', initialValue: [] })
const promocodeStore = createState({ key: 'promocode' })

export const state = () => ({
  promocode: promocodeStore.state,
  interestingPromocodes: interestingPromocodesStore.state,
})

export const mutations = {
  set_promocode: promocodeStore.setter,
  set_interestingPromocodes: interestingPromocodesStore.setter,
}

export const actions = {
  async send_promocode({ commit, getters }, { code }) {
    if (getters.get_promocode.isLoading) return
    commit('set_promocode', { isLoading: true })
    try {
      const res = await this.$api.promocodes.promocode({ code })
      commit('set_promocode', { data: res.data })
      return res?.data
    }
    catch (e) {
      commit('set_promocode', { error: e })
    }
    finally {
      commit('set_promocode', { isLoading: false })
    }
  },
  // async fetch_interestingPromocodes({ commit, getters }) {
  //   if (getters.get_interestingPromocodes.isLoading) return
  //   commit('set_interestingPromocodes', { isLoading: true })
  //   try {
  //     const res = await this.$api.promocodes.getActivationInfo()
  //     if (res.data) commit('set_interestingPromocodes', { data: res.data.promocodes })
  //   }
  //   catch (e) {
  //     commit('set_interestingPromocodes', { error: e })
  //   }
  //   finally {
  //     commit('set_interestingPromocodes', { isLoading: false })
  //   }
  // },
}

export const getters = {
  get_promocode: (state) => {
    const promocodeGetter = promocodeStore.getter(state)
    const timeout = Math.round(promocodeGetter.data?.timeoutExpiredInMs / 1000) || 0

    return {
      ...promocodeGetter,
      timeout,
    }
  },
  get_interestingPromocodes: interestingPromocodesStore.getter,
}
